/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PageUpcomingTechnicalMaintenanceWorkInfo,
  Pageable,
  SchedulerItem,
  TechnicalMaintenance,
  TechnicalMaintenanceWork,
  TechnicalMaintenanceWorkRequest,
  ValidationErrorResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PageUpcomingTechnicalMaintenanceWorkInfoFromJSON,
    PageUpcomingTechnicalMaintenanceWorkInfoToJSON,
    PageableFromJSON,
    PageableToJSON,
    SchedulerItemFromJSON,
    SchedulerItemToJSON,
    TechnicalMaintenanceFromJSON,
    TechnicalMaintenanceToJSON,
    TechnicalMaintenanceWorkFromJSON,
    TechnicalMaintenanceWorkToJSON,
    TechnicalMaintenanceWorkRequestFromJSON,
    TechnicalMaintenanceWorkRequestToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';

export interface AddWorkRequest {
    timeNormativeId: string;
    technicalMaintenanceWorkRequest: TechnicalMaintenanceWorkRequest;
}

export interface DeleteWorkRequest {
    workId: string;
}

export interface FindAllByDrillingRigEquipmentIdRequest {
    drillingRigEquipmentId: number;
}

export interface FindById1Request {
    timeNormativeId: string;
}

export interface GetCalendarViewRequest {
    drillingRigEquipmentId: number;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface GetJsonSchemaRequest {
    drillingRigId?: number;
    rigEquipmentTypeId?: number;
}

export interface GetTechnicalMaintenanceWorkInfoByDrillingRigRequest {
    drillingRigId: number;
    rigEquipmentTypeId: number;
    pageable: Pageable;
}

export interface GetUpcomingTechnicalMaintenanceWorkInfoRequest {
    drillingRigId: number;
    pageable: Pageable;
    daysAdvance?: number;
}

export interface SetIsNotBeenMonitoredRequest {
    timeNormativeId: string;
    value: boolean;
}

export interface UpdateWorkRequest {
    workId: string;
    technicalMaintenanceWorkRequest: TechnicalMaintenanceWorkRequest;
}

/**
 * 
 */
export class DrillingRigTechnicalMaintenanceWorkControllerApi extends runtime.BaseAPI {

    /**
     */
    async addWorkRaw(requestParameters: AddWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TechnicalMaintenanceWork>> {
        if (requestParameters['timeNormativeId'] == null) {
            throw new runtime.RequiredError(
                'timeNormativeId',
                'Required parameter "timeNormativeId" was null or undefined when calling addWork().'
            );
        }

        if (requestParameters['technicalMaintenanceWorkRequest'] == null) {
            throw new runtime.RequiredError(
                'technicalMaintenanceWorkRequest',
                'Required parameter "technicalMaintenanceWorkRequest" was null or undefined when calling addWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/{timeNormativeId}/works`.replace(`{${"timeNormativeId"}}`, encodeURIComponent(String(requestParameters['timeNormativeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TechnicalMaintenanceWorkRequestToJSON(requestParameters['technicalMaintenanceWorkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnicalMaintenanceWorkFromJSON(jsonValue));
    }

    /**
     */
    async addWork(requestParameters: AddWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TechnicalMaintenanceWork> {
        const response = await this.addWorkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteWorkRaw(requestParameters: DeleteWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling deleteWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/works/{workId}`.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteWork(requestParameters: DeleteWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWorkRaw(requestParameters, initOverrides);
    }

    /**
     */
    async findAllByDrillingRigEquipmentIdRaw(requestParameters: FindAllByDrillingRigEquipmentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TechnicalMaintenance>>> {
        if (requestParameters['drillingRigEquipmentId'] == null) {
            throw new runtime.RequiredError(
                'drillingRigEquipmentId',
                'Required parameter "drillingRigEquipmentId" was null or undefined when calling findAllByDrillingRigEquipmentId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['drillingRigEquipmentId'] != null) {
            queryParameters['drillingRigEquipmentId'] = requestParameters['drillingRigEquipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/findAllByDrillingRigEquipmentId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TechnicalMaintenanceFromJSON));
    }

    /**
     */
    async findAllByDrillingRigEquipmentId(requestParameters: FindAllByDrillingRigEquipmentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TechnicalMaintenance>> {
        const response = await this.findAllByDrillingRigEquipmentIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findById1Raw(requestParameters: FindById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TechnicalMaintenance>> {
        if (requestParameters['timeNormativeId'] == null) {
            throw new runtime.RequiredError(
                'timeNormativeId',
                'Required parameter "timeNormativeId" was null or undefined when calling findById1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/{timeNormativeId}`.replace(`{${"timeNormativeId"}}`, encodeURIComponent(String(requestParameters['timeNormativeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnicalMaintenanceFromJSON(jsonValue));
    }

    /**
     */
    async findById1(requestParameters: FindById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TechnicalMaintenance> {
        const response = await this.findById1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCalendarViewRaw(requestParameters: GetCalendarViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SchedulerItem>>> {
        if (requestParameters['drillingRigEquipmentId'] == null) {
            throw new runtime.RequiredError(
                'drillingRigEquipmentId',
                'Required parameter "drillingRigEquipmentId" was null or undefined when calling getCalendarView().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['drillingRigEquipmentId'] != null) {
            queryParameters['drillingRigEquipmentId'] = requestParameters['drillingRigEquipmentId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/calendar-view`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SchedulerItemFromJSON));
    }

    /**
     */
    async getCalendarView(requestParameters: GetCalendarViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SchedulerItem>> {
        const response = await this.getCalendarViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getJsonSchemaRaw(requestParameters: GetJsonSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['drillingRigId'] != null) {
            queryParameters['drillingRigId'] = requestParameters['drillingRigId'];
        }

        if (requestParameters['rigEquipmentTypeId'] != null) {
            queryParameters['rigEquipmentTypeId'] = requestParameters['rigEquipmentTypeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/schema`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getJsonSchema(requestParameters: GetJsonSchemaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getJsonSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getJsonSchemaForUpcomingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/upcoming/schema`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getJsonSchemaForUpcoming(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getJsonSchemaForUpcomingRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTechnicalMaintenanceWorkInfoByDrillingRigRaw(requestParameters: GetTechnicalMaintenanceWorkInfoByDrillingRigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageUpcomingTechnicalMaintenanceWorkInfo>> {
        if (requestParameters['drillingRigId'] == null) {
            throw new runtime.RequiredError(
                'drillingRigId',
                'Required parameter "drillingRigId" was null or undefined when calling getTechnicalMaintenanceWorkInfoByDrillingRig().'
            );
        }

        if (requestParameters['rigEquipmentTypeId'] == null) {
            throw new runtime.RequiredError(
                'rigEquipmentTypeId',
                'Required parameter "rigEquipmentTypeId" was null or undefined when calling getTechnicalMaintenanceWorkInfoByDrillingRig().'
            );
        }

        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling getTechnicalMaintenanceWorkInfoByDrillingRig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['drillingRigId'] != null) {
            queryParameters['drillingRigId'] = requestParameters['drillingRigId'];
        }

        if (requestParameters['rigEquipmentTypeId'] != null) {
            queryParameters['rigEquipmentTypeId'] = requestParameters['rigEquipmentTypeId'];
        }

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/findByDrillingRigId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUpcomingTechnicalMaintenanceWorkInfoFromJSON(jsonValue));
    }

    /**
     */
    async getTechnicalMaintenanceWorkInfoByDrillingRig(requestParameters: GetTechnicalMaintenanceWorkInfoByDrillingRigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageUpcomingTechnicalMaintenanceWorkInfo> {
        const response = await this.getTechnicalMaintenanceWorkInfoByDrillingRigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUpcomingTechnicalMaintenanceWorkInfoRaw(requestParameters: GetUpcomingTechnicalMaintenanceWorkInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageUpcomingTechnicalMaintenanceWorkInfo>> {
        if (requestParameters['drillingRigId'] == null) {
            throw new runtime.RequiredError(
                'drillingRigId',
                'Required parameter "drillingRigId" was null or undefined when calling getUpcomingTechnicalMaintenanceWorkInfo().'
            );
        }

        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling getUpcomingTechnicalMaintenanceWorkInfo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['drillingRigId'] != null) {
            queryParameters['drillingRigId'] = requestParameters['drillingRigId'];
        }

        if (requestParameters['daysAdvance'] != null) {
            queryParameters['daysAdvance'] = requestParameters['daysAdvance'];
        }

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/upcoming`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUpcomingTechnicalMaintenanceWorkInfoFromJSON(jsonValue));
    }

    /**
     */
    async getUpcomingTechnicalMaintenanceWorkInfo(requestParameters: GetUpcomingTechnicalMaintenanceWorkInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageUpcomingTechnicalMaintenanceWorkInfo> {
        const response = await this.getUpcomingTechnicalMaintenanceWorkInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setIsNotBeenMonitoredRaw(requestParameters: SetIsNotBeenMonitoredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TechnicalMaintenance>> {
        if (requestParameters['timeNormativeId'] == null) {
            throw new runtime.RequiredError(
                'timeNormativeId',
                'Required parameter "timeNormativeId" was null or undefined when calling setIsNotBeenMonitored().'
            );
        }

        if (requestParameters['value'] == null) {
            throw new runtime.RequiredError(
                'value',
                'Required parameter "value" was null or undefined when calling setIsNotBeenMonitored().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['value'] != null) {
            queryParameters['value'] = requestParameters['value'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/{timeNormativeId}/set-is-not-been-monitored`.replace(`{${"timeNormativeId"}}`, encodeURIComponent(String(requestParameters['timeNormativeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnicalMaintenanceFromJSON(jsonValue));
    }

    /**
     */
    async setIsNotBeenMonitored(requestParameters: SetIsNotBeenMonitoredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TechnicalMaintenance> {
        const response = await this.setIsNotBeenMonitoredRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateWorkRaw(requestParameters: UpdateWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TechnicalMaintenanceWork>> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling updateWork().'
            );
        }

        if (requestParameters['technicalMaintenanceWorkRequest'] == null) {
            throw new runtime.RequiredError(
                'technicalMaintenanceWorkRequest',
                'Required parameter "technicalMaintenanceWorkRequest" was null or undefined when calling updateWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/technical-maintenance/works/{workId}`.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TechnicalMaintenanceWorkRequestToJSON(requestParameters['technicalMaintenanceWorkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnicalMaintenanceWorkFromJSON(jsonValue));
    }

    /**
     */
    async updateWork(requestParameters: UpdateWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TechnicalMaintenanceWork> {
        const response = await this.updateWorkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
